export const reportsSection = "/reports/";

export const reportsOverviewPath = reportsSection;
export const reportsOverviewUrl = reportsSection;
